import { render, staticRenderFns } from "./NoBottled.vue?vue&type=template&id=08c6fcaf&scoped=true&"
import script from "./NoBottled.vue?vue&type=script&lang=js&"
export * from "./NoBottled.vue?vue&type=script&lang=js&"
import style0 from "./NoBottled.vue?vue&type=style&index=0&id=08c6fcaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c6fcaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c6fcaf')) {
      api.createRecord('08c6fcaf', component.options)
    } else {
      api.reload('08c6fcaf', component.options)
    }
    module.hot.accept("./NoBottled.vue?vue&type=template&id=08c6fcaf&scoped=true&", function () {
      api.rerender('08c6fcaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/assessments/NoBottled.vue"
export default component.exports